<template>
  <component :is="wrapper">
    <slot :data="data">
      <ul>
        <li v-for="item in data" :key="`nav-item-${item.id}`">
          <NuxtLinkLocale
            :prefetch="true"
            :prefetched-class="'prefetched'"
            :to="`${item.path.startsWith('/') ? '' : '/'}${item.path}`"
          >
            {{ item.title }}
          </NuxtLinkLocale>
        </li>
      </ul>
    </slot>
  </component>
</template>

<script setup lang="ts">
import {
  useAsyncData,
  useI18n,
  useStrapiClient,
  useNuxtApp,
  computed,
} from "#imports";
import type { ConcreteComponent } from "vue";
import type { StrapiNavigation } from "../../../../src/types";

const client = useStrapiClient();
const { locale } = useI18n();
const nuxtApp = useNuxtApp();

const props = withDefaults(
  defineProps<{
    wrapper?: ConcreteComponent | string;
    navigation?: string;
    type?: "TREE" | "RFR" | "FLAT";
  }>(),
  {
    wrapper: "div",
    navigation: "primary",
    type: "FLAT",
  },
);

const url = computed(
  () =>
    `navigation/render/${props.navigation}?locale=${locale.value}&type=${props.type}`,
);

const { data } = await useAsyncData(
  url.value,
  () => client<StrapiNavigation[]>(url.value, {}),
  {
    immediate: true,
    watch: [url],
    getCachedData: (key) =>
      nuxtApp.$config.public.flyingkiwi.enableCache
        ? nuxtApp.payload.data[key] || nuxtApp.static.data[key]
        : nuxtApp.isHydrating
          ? nuxtApp.payload.data[key]
          : nuxtApp.static.data[key],
  },
);
</script>
